export const MAX_PICTURE_SIZE = 4194304; // in bytes
export const GOOGLE_PLAY_APP_LINK = "https://play.google.com/store/apps/details?id=com.sokraft.pannoniaeat";
export const APP_STORE_APP_LINK = "https://apps.apple.com/us/app/pannoniaeat/id1619099943";